import { clx, useMediaQuery } from "@hm/fundamental"
import { FormEvent, ReactNode } from "react"

import { FormSummary } from "./form-summary"

interface FormWithSummaryProps {
	"data-cy": string
	formContent: ReactNode
	summaryContent: ReactNode
	isValid: boolean
	summaryTitle: string
	submitTitle: string
	submitIcon: string
	backTitle?: string
	onBack?: () => void
	onSubmit: (e: FormEvent<HTMLFormElement>) => void
}

export const FormWithSummary: React.FC<FormWithSummaryProps> = ({
	"data-cy": dataCy,
	formContent,
	summaryContent,
	isValid,
	summaryTitle,
	submitTitle,
	submitIcon,
	backTitle,
	onBack,
	onSubmit,
}) => {
	const isLessThanLargeScreen = useMediaQuery({
		breakpoint: "lg",
		upTo: true,
	})

	return (
		<form data-cy={dataCy} onSubmit={onSubmit}>
			<div
				data-cy={`${dataCy}-container`}
				className="flex max-lg:flex-col lg:gap-12"
			>
				<div
					data-cy={`${dataCy}-content-container`}
					className={clx(
						"h-auto max-lg:w-full xl:w-[calc(61%-24px)] lg:w-[calc(58.6%-24px)]",
						isLessThanLargeScreen && "mb-32",
					)}
				>
					{formContent}
				</div>
				<FormSummary
					dataCy={dataCy}
					summaryTitle={summaryTitle}
					summaryContent={summaryContent}
					submitTitle={submitTitle}
					submitIcon={submitIcon}
					backTitle={backTitle}
					onBack={onBack}
					isLessThanLargeScreen={isLessThanLargeScreen}
					isValid={isValid}
				/>
			</div>
		</form>
	)
}
